import { BaseExportModal } from './ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { useMemo } from 'react'
import { INVOICE_COLUMNS } from 'features/tradespend/invoiceColumnInfo'
import { useDownload } from 'features/download-widget'
import { exportManufacturerInvoices } from 'services/downloadsApi'
import { useColumnStoreContext } from 'stores/ColumnsStore/useColumnsStoreContext'

interface InvoiceExportModalProps {
  show: boolean
  _handleClose: () => void
}

export default function InvoiceExportModal(props: InvoiceExportModalProps) {
  const { startDownload } = useDownload()
  const selectedColumns = useColumnStoreContext(
    (state) => state.selectedColumns
  )

  const invoiceColumnHelper = createExportColumnHelper({
    columns: INVOICE_COLUMNS,
  })

  const columns = useMemo(() => {
    return [
      {
        title: 'Invoice Details',
        elements: [
          invoiceColumnHelper.retrieveColumn('created'),
          invoiceColumnHelper.retrieveColumn('amount'),
          invoiceColumnHelper.retrieveColumn('claim_count'),
          invoiceColumnHelper.retrieveColumn('due_date'),
          invoiceColumnHelper.retrieveColumn('status'),
          invoiceColumnHelper.retrieveColumn('paid_at'),
        ],
      },
    ]
  }, [])

  const onSubmit = async (
    selectedCols: string[],
    exportType: 'csv' | 'xlsx'
  ) => {
    await startDownload({
      items: [{ id: 0, name: 'Exporting Invoices...' }],
      initiate: async (signal) => {
        const result = await exportManufacturerInvoices(
          { selected_columns: selectedCols, export_type: exportType },
          signal
        )
        return { type: 'blob', blob: result.blob, filename: result.filename }
      },
      label: 'invoices',
    })
  }

  return (
    <BaseExportModal
      title="Select Columns for Invoices Download"
      subTitle="Download up to 10,000 invoices at a time, with any of the following columns."
      submitText="Export Invoices"
      columns={columns}
      selectedColumns={selectedColumns}
      onSubmit={onSubmit}
      show={props.show}
      handleClose={props._handleClose}
    />
  )
}
